<template>
  <div>
    <Toast/>
    <div class="card">
      <Steps :model="items" :readonly="true"/>
    </div>
    <Card>
      <template #header>
      </template>
      <template #title>
        Dirección
      </template>
      <template v-slot:subtitle>
        Añadir distribuidor
      </template>
      <template #content>
        <div class="field">
          <!--         Estado-->
          <Dropdown v-model="selectedEstado" :options="estados"
                    optionLabel="testado" optionValue="id_estado"
                    placeholder="Seleccionar Estado" class="filterItem" :loading="loadingEstado"
                    :showClear="true"
                    style="width: 100%"
                    :onChange="refreshMunicipios"
                    :filter="true"/>
          <!--        Municipio-->
          <Dropdown v-model="selectedMunicipio" :options="municipios"
                    optionLabel="tmunicipio" optionValue="id_municipio"
                    placeholder="Seleccionar Municipio" class="filterItem" :loading="loadingMunicipio"
                    :showClear="true"
                    v-if="selectedEstado"
                    style="width: 100%"
                    :filter="true"/>
        </div>
      </template>
      <template #footer>
        <div class="grid grid-nogutter justify-content-between">
          <Button label="Anterior" @click="prevPage()" icon="pi pi-angle-left"/>
          <Button label="Siguiente"
                  @click="nextPage()"
                  icon="pi pi-angle-right"
                  iconPos="right"
                  :disabled="this.selectedMunicipio ? disabled : ''"/>
        </div>
      </template>
    </Card>

    <router-view v-slot="{Component}" @prevPage="prevPage($event)" @nextPage="nextPage($event)">
      <keep-alive>
        <component :is="Component"/>
      </keep-alive>
    </router-view>
  </div>
  <Toast/>
</template>

<script>
import MainService from "@/service/backend/MainService";
import generalMixin from "@/mixins/generalMixin";
import DistributorService from "@/service/backend/DistributorService";

export default {
  name: "Step3",
  mixins: [generalMixin],
  created() {
    this.mainService = new MainService;
    this.distributorService = new DistributorService;
    this.$primevue.config.locale.emptyMessage = "Buscando opciones...";
  },
  mounted() {
    this.refreshEstados();
    this.selectedEstado = this.$store.getters.getDistributor.id_estado;
    this.refreshMunicipios();
    this.selectedMunicipio = this.$store.getters.getDistributor.id_municipio;
  },
  data() {
    return {
      items: [
        {
          label: 'Nombre',
          to: '/distribuidores/agregar-1'
        },
        {
          label: 'Cadena de comercialización',
          to: '/distribuidores/agregar-2'
        },
        {
          label: 'Dirección',
          to: '/distribuidores/agregar-3'
        },
      ],
      selectedEstado: null,
      selectedMunicipio: null,
      estados: null,
      municipios: null,
      loadingEstado: false,
      loadingMunicipio: false,
      params: null,
      pageIndex: 1,
      id_psxcmxbanxdis: null,
    }
  },
  methods: {
    async refreshEstados() {
      this.municipios = null;
      this.estados = await this.mainService.getEstados();
    },
    async refreshMunicipios() {
      if (this.selectedEstado) {
        this.municipios = await this.mainService.getMunicipios({id_estado: this.selectedEstado});
      }
    },
    async createDistributor() {
      let response;
      try {
        response = await this.distributorService.createDistributor({
          tdistribuidor: this.$store.getters.getDistributor.distributorName,
          id_comercializador: this.$store.getters.getProfile.id_comercializador
              ? this.$store.getters.getProfile.id_comercializador
              : this.$store.getters.getDistributor.id_comercializador,
          id_banca: this.$store.getters.getProfile.id_banca
              ? this.$store.getters.getProfile.id_banca
              : this.$store.getters.getDistributor.id_banca,
          id_estado: this.$store.getters.getDistributor.id_estado,
          id_municipio: this.$store.getters.getDistributor.id_municipio,
          trif_agencia: '',
          tcorreo_electronico: '',
        });
      } catch (e) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: `No se pudo crear el distribuidor ${this.$store.getters.getDistributor.distributorName}| ` + e.message,
          life: 10000
        });
        this.overlay = false;
        return false;
      }

      if (response.error) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: `No se pudo crear el distribuidor ${this.$store.getters.getDistributor.distributorName}| ` + response.error,
          life: 10000
        });
        this.overlay = false;
        return false;
      } else {
        this.idDistributor = response[0].id_dis;
        this.id_psxcmxbanxdis = await this.distributorService.fecthDistributorPsxcmxbanxdis({
          id_distribuidor: this.idDistributor,
        })


        this.$store.commit('setDistributor', {
              distributorName: this.$store.getters.getDistributor.distributorName,
              id_comercializador: this.$store.getters.getDistributor.id_comercializador,
              id_banca: this.$store.getters.getDistributor.id_banca,
              id_estado: this.selectedEstado,
              id_municipio: this.selectedMunicipio,
              id_distribuidor: this.idDistributor,
              id_psxcmxbanxdis: this.id_psxcmxbanxdis,
            }
        );
        return true;
      }
    },
    async nextPage() {
      this.$store.commit('setDistributor', {
        distributorName: this.$store.getters.getDistributor.distributorName,
        id_comercializador: this.$store.getters.getDistributor.id_comercializador,
        id_banca: this.$store.getters.getDistributor.id_banca,
        id_estado: this.selectedEstado,
        id_municipio: this.selectedMunicipio,
        id_psxcmxbanxdis: this.id_psxcmxbanxdis,
      });
      if (await this.createDistributor()) {
        this.$router.push({name: 'distribuidores',});
      }
    },
    prevPage() {
      this.$store.commit('setDistributor', {
        distributorName: this.$store.getters.getDistributor.distributorName,
        id_comercializador: this.$store.getters.getDistributor.id_comercializador,
        id_banca: this.$store.getters.getDistributor.id_banca,
        id_estado: this.selectedEstado,
        id_municipio: this.selectedMunicipio,
        id_distribuidor: this.idDistributor,
        id_psxcmxbanxdis: this.id_psxcmxbanxdis,
      });
      this.$router.push('/distribuidores/agregar-2');
    },
  }
}
</script>

<style scoped lang="scss">
.filterItem {
  margin: 20px 0 5px 0;
}

</style>